import SiteSearchGroup from '@/components/search-group'
import user from '@/api/user'
import role from '@/api/role'
import journal from '@/api/journal'
import Add from './add.dialog.vue'
import help from '@/utils/help'
import { mapGetters } from 'vuex'
const columns = [
  {
    title: '',
    enTitle: 'Email',
    width: 220,
    dataIndex: 'email',
    slot: 'email',
  },
  {
    title: '',
    enTitle: 'Name',
    width: 200,
    dataIndex: 'name',
    slot: 'name',
  },
  // {
  //   title: '',
  //   enTitle: 'Department',
  //   width: 200,
  //   dataIndex: 'departmentList',
  //   slot: 'roles'
  // },
  {
    title: '',
    enTitle: 'Roles',
    width: 200,
    dataIndex: 'roleList',
    slot: 'roles',
  },
  {
    title: '',
    enTitle: 'Status',
    width: 80,
    dataIndex: 'enabled',
    slot: 'status',
  },
  {
    title: '',
    enTitle: 'Created Time',
    width: 200,
    dataIndex: 'createTime',
    slot: 'time',
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 190,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions',
  },
]

export default {
  components: {
    SiteSearchGroup,
    Add,
  },
  data() {
    return {
      columns,
      isVisable: false,
      params: {
        like: '',
        journalId: '',
        journal: '',
        roles: '',
        country: '',
        category: '',
      },
      roleIdListArr: [],
      inputData: {},

      showAdv: false,
      journalList: [],
      roles: [],
      dataSource: [],
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true,
      },
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
    }),
  },
  async mounted() {
    await this.getRoles()
    await this.getJournalList()
  },
  methods: {
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size,
        roleIdList: this.roleIdListArr.length
          ? this.roleIdListArr.join(',')
          : '',
      })
      const { list, pageIndex, pageSize, total } = await user.get(data)
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex,
      })
    },
    async getRoles(name = '') {
      this.roles = await role.get({ outSided: false, name })
    },
    // 获取journalist列表
    async getJournalList() {
      this.journalList = await journal.userGet()

      this.journalList.unshift({
        name: 'All',
        journalId: '',
        id: '',
      })
      // console.log(this.journalList, 'this.journalList')
      const flag = this.journalList.some((item) => {
        if (item.id === localStorage.getItem('journalId')) {
          this.params.journalId = item.id
          return true
        }
      })
      if (!flag) {
        this.params.journalId = this.journalList[0] && this.journalList[0].id
        localStorage.setItem('journalId', this.params.journalId)
      }

      this.changeJournal(this.params.journalId)
      this.getList()
    },

    handleClear() {
      this.params.keyword = ''
      this.params.journalId = ''
      this.params.roleId = ''
      this.getList()
    },

    changeJournal(val) {
      this.getList()
      localStorage.setItem('journalId', val)
    },

    detail(val) {
      help.openWindow(
        `/user-manage/manage-employees/${val.id}/action-authority`
      )
      // this.$router.push(
      //   `/user-manage/manage-employees/${val.id}/action-authority`
      // )
    },
    add() {
      this.isVisable = true
    },
    edit(val) {
      this.inputData = val
      this.isVisable = true
    },
    async able(val) {
      const { id, enabled, version } = val
      await user.setEnabled(id, !enabled, { version })
      let content = 'This Employee has been published!'
      if (enabled) {
        content = 'This Employee has been unpublished!'
      }
      this.$message.success({
        title: 'Success',
        content: content,
      })
      this.getList()
    },
    del(val) {
      this.$confirm({
        title: 'Delete the employee',
        content: `Are you sure you want to delete this Employee? <br>
          Please be aware that once this employee is deleted, it will never be able to be recovered.`,
        type: 'danger',
        icon: 'iconDelete',
        confirmText: 'Delete',
      }).then(async () => {
        await user.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This Employee has been deleted!',
        })
        this.getList()
      })
    },
    confirm() {
      this.inputData = {}
      this.isVisable = false
      this.getList()
    },
    cancel() {
      this.inputData = {}
      this.isVisable = false
    },
    async exp() {
      const res = await user.export(this.params)
      help.download(res.url, res.fileName)
    },
  },
}
